import { useQuery } from "@apollo/client";
import { QR_LIST_PERSON } from "../graphql/queries";

// Wrapper mince autour de QR_LIST_PERSON, mutualisé entre useManageUsers (ManageUsers) et
// useInbox (Inbox). Ne décide de rien pour l'appelant : passe telles quelles les options Apollo
// (context, skip, fetchPolicy...) pour ne pas changer le comportement des usages existants.
export const useListPersons = (variables, queryOptions = {}) =>
  useQuery(QR_LIST_PERSON, { variables, ...queryOptions });
